import { ModalContextProvider } from 'utils/contexts/modal';
import { Editor } from './Editor';
import { EditorContextProvider } from './contexts/editor/provider';
import { FormattingContextProvider } from './contexts/formatting';
import { HyperlinkModal } from './hyperlinkModal';
import { SnippetModal } from './SnippetModal';
import { MergeTagsContextProvider } from './contexts/mergeTags';

export const CustomTextInput = () => (
  <ModalContextProvider>
    <EditorContextProvider>
      <MergeTagsContextProvider>
        <FormattingContextProvider>
          <SnippetModal />
          <HyperlinkModal />
          <Editor />
        </FormattingContextProvider>
      </MergeTagsContextProvider>
    </EditorContextProvider>
  </ModalContextProvider>
);
